import { FullAudit, LevelModel } from '@/types';

export interface SpamNumberModel extends FullAudit {
    id: number;
    level: LevelModel;
    number: string;
    active: boolean;
}
